import { render, staticRenderFns } from "./ViewCustomerGroupContainer.vue?vue&type=template&id=366c96cc&scoped=true&"
import script from "./ViewCustomerGroupContainer.vue?vue&type=script&lang=js&"
export * from "./ViewCustomerGroupContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366c96cc",
  null
  
)

export default component.exports